import { AiFillDashboard, AiOutlineDashboard } from "react-icons/ai";
import {
  BsCalendarPlus,
  BsCalendarPlusFill,
  BsPeople,
  BsPeopleFill,
} from "react-icons/bs";
import { HiOutlineQueueList, HiQueueList } from "react-icons/hi2";
import { IoSettingsOutline, IoSettingsSharp } from "react-icons/io5";
import { MdManageAccounts, MdOutlineManageAccounts } from "react-icons/md";
import i18n from "src/i18n";

import { ROLES } from "@constants/index";
import { firstAccessibleAccountPath } from "@data/accountManagementNavLinks";


export const getSidebarLinks = (canAccessPath: (path: string) => boolean) => {
  const links = [
    {
      title: i18n.t("dashboard"),
      link: "dashboard/admin",
      iconOutline: AiOutlineDashboard,
      iconFill: AiFillDashboard,
      isEnabled: true,
      roles: [ROLES.ADMIN],
    },
    {
      title: i18n.t("dashboard"),
      link: "dashboard/staff",
      iconOutline: AiOutlineDashboard,
      iconFill: AiFillDashboard,
      isEnabled: true,
      roles: [ROLES.DOCTOR, ROLES.NURSE],
    },
    {
      title: i18n.t("patients"),
      link: "patients",
      iconOutline: BsPeople,
      iconFill: BsPeopleFill,
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.DOCTOR, ROLES.NURSE],
    },
    {
      title: i18n.t("appointments"),
      link: "appointments", // If this is made "appointments/booked", "/incoming" will be inaccessible to all the roles until it is also explicitly defined
      iconOutline: BsCalendarPlus,
      iconFill: BsCalendarPlusFill,
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.DOCTOR, ROLES.RECEPTIONIST],
    },
    {
      title: i18n.t("queue"),
      link: "queue",
      iconOutline: HiOutlineQueueList,
      iconFill: HiQueueList,
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.DOCTOR, ROLES.RECEPTIONIST],
    },
    {
      title: i18n.t("accounts"),
      link: firstAccessibleAccountPath(canAccessPath),
      iconOutline: MdOutlineManageAccounts,
      iconFill: MdManageAccounts,
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.DOCTOR, ROLES.NURSE, ROLES.RECEPTIONIST],
    },
    {
      title: i18n.t("settings"),
      link: "settings/admin/resource-management",
      iconOutline: IoSettingsOutline,
      iconFill: IoSettingsSharp,
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.DOCTOR, ROLES.NURSE, ROLES.RECEPTIONIST],
    },
    // {
    //   title: i18n.t("settings"),
    //   link: "settings/staff",
    //   iconOutline: IoSettingsOutline,
    //   iconFill: IoSettingsSharp,
    //   isEnabled: true,
    //   roles: [ROLES.DOCTOR, ROLES.NURSE, ROLES.RECEPTIONIST],
    // },
  ];

  // Filter links based on roles
  const filteredLinks = links.filter(link => {
    return canAccessPath(link.link) && !(link.link === "dashboard/staff" && canAccessPath("dashboard/admin"));
  });

  return filteredLinks;
};
